import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { NarrowcastingState } from '@/store/narrowcasting/index'


export const getters: GetterTree<NarrowcastingState, RootState> = {
}
